import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  markedAsNotInterested: [],
};

const NotInterestedSlice = createSlice({
  name: "NotInterested",
  initialState,
  reducers: {
    loadNotInterestedFromAPI: (state, action) => {
      state.markedAsNotInterested = action.payload || [];
    },
    addToNotInterested: (state, action) => {
      const userId = action.payload;
      if (!state.markedAsNotInterested.includes(userId)) {
        state.markedAsNotInterested.push(userId);
      }
    },
    removeFromNotInterested: (state, action) => {
      const userId = action.payload;
      state.markedAsNotInterested = state.markedAsNotInterested.filter(
        (id) => id !== userId
      );
    },
    clearNotInterested: (state) => {
      state.markedAsNotInterested = [];
    },
  },
});

export const {
  loadNotInterestedFromAPI,
  addToNotInterested,
  removeFromNotInterested,
  clearNotInterested,
} = NotInterestedSlice.actions;

export default NotInterestedSlice.reducer;
